import { PatchRequestBody } from '../interfaces/patch-body.model';

export const createPatchRequestData = (data: object, op = 'replace'): PatchRequestBody[] => {
    return Object.entries(data).map(([key, value]) => ({
        op,
        path: `/${key}`,
        value: typeof value === 'object' && !Array.isArray(value) && value?.id ? value.id : value,
    }));
};
